module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\r\n<div class=\"app\">\r\n  <div ui-view></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 490
// module chunks = 0